import { useState } from 'react'
import { CheckIcon, CopyIcon } from 'lucide-react'
import { Button } from './ui/button'

export function CopyButton({ text }: { text: string }) {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(text)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  const displayText =
    text.length > 16 ? `${text.slice(0, 6)}...${text.slice(-4)}` : text

  return (
    <Button variant="outline" className="text-black" onClick={handleCopy}>
      {copied ? (
        <CheckIcon className="size-4" />
      ) : (
        <CopyIcon className="size-4" />
      )}
      {displayText}
    </Button>
  )
}
